module.exports = __webpack_public_path__ + "media/images/btn_save_file-93d22e6c2c01370f1d2908f468b378d2.gif";